(function ($, XTT) {
	'use strict';

	XTT.faq = {
		_autoload: [
			'bindFaqEvents'
		],

		bindFaqEvents: function () {
			$('.faq--single .faq__question').on('click', XTT.faq.handleFaqToggle);
		},

		handleFaqToggle: function(e) {
			$(this).toggleClass('open');
			$(this).next('div').toggleClass('open');
			e.preventDefault();
		}

	};

})
(jQuery, XTT);